export default "__VITE_ASSET__DV_uXuI2__"